import React from 'react';
import { ACCEPTED_VIDEOS, LANGUAGE_NAMES, DEFAULT_LANGUAGE } from '../../../../service/constants';
import MediaUpload from '../MediaUpload';

const VideosSection = ({ demo, video, onDemoChange, onVideoChange, demoError, videoError, lang = DEFAULT_LANGUAGE }) => {
    const languageLabel = LANGUAGE_NAMES[lang] || "";
    const languageSuffix = ` (${languageLabel})`;
    
    return (
        <>
            <MediaUpload
                label={`Demo${languageSuffix}`}
                name="demo"
                value={demo}
                accept={ACCEPTED_VIDEOS}
                onChange={onDemoChange}
                error={demoError}
                maxHeight="200px"
            />
            <MediaUpload
                label={`Completo${languageSuffix}`}
                name="video"
                value={video}
                accept={ACCEPTED_VIDEOS}
                onChange={onVideoChange}
                error={videoError}
                maxHeight="200px"
            />
        </>
    );
};

export default VideosSection;
